
export const buyReducer = (state = [], action) => {

    switch (action.type) {
        case '[BUY] Load list':
            return {
                ...state,
                buys: action.payload
            }

        case '[BUY] Set totals':
            return {
                ...state,
                totals: action.payload
            }

        case '[BUY] set detail':
            return {
                ...state,
                detailBuy: action.payload
            }

        default:
            return state
    }


}